export enum FieldType {
    'DETAILS' = 'details',
    'DESCRIPTION' = 'description',
    'HOW_TO_USE' = 'howToUse',
    'INGREDIENTS' = 'ingredients'
}
